export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40372ba80df98f4f6f5fbf482ba609cf3deb5f07e1&name=revalidateCommunity!'